import DocumentPeriodFilter from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/DocumentPeriodFilter';
import DocumentTypeFilter from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/DocumentTypeFilter';
import DocumentStatusFilter from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/DocumentStatusFilter';
import useAccountDocumentTypes from '@UI/Hooks/useAccountDocumentTypes';
import type DocumentView from '@UI/Store/Documents/Views/DocumentView';
import * as React from 'react';
import { Grid, GridItem } from '@verclam/grid-system';

type Props = {
	readonly documents: readonly DocumentView[];
};

/**
 * The type options are the types present in this dossier's documents, not the whole catalogue: a
 * type with no document would only ever yield an empty list. The catalogue is loaded here, once,
 * to label them.
 */
const Filters: React.FC<Props> = ({ documents }) => {
	const { documentTypes, error } = useAccountDocumentTypes();

	const typeOptions = React.useMemo(() => {
		const typeIds = [...new Set(documents.map((document) => document.documentTypeId))];

		return typeIds
			.map((id) => ({ id, label: documentTypes?.labelOf(id) ?? 'Type inconnu' }))
			.sort((first, second) => first.label.localeCompare(second.label, 'fr'));
	}, [documents, documentTypes]);

	const isLoadingTypes = documentTypes === null && error === null;

	return (
		<Grid columns={12} columnGap={1} rowGap={1} alignItems="end">
			<GridItem columnSize={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }}>
				<DocumentTypeFilter options={typeOptions} loading={isLoadingTypes} />
			</GridItem>
			<GridItem columnSize={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }}>
				<DocumentPeriodFilter />
			</GridItem>
			<GridItem columnSize={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }}>
				<DocumentStatusFilter />
			</GridItem>
		</Grid>
	);
};

export default Filters;
